// extracted by mini-css-extract-plugin
export default {"back":"InfoFormPage_back__5aBli","form":"InfoFormPage_form__FMApv"};